import React from 'react';
import NoSelected from "../../Utils/NoSelected";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronRight, faMinus} from "@fortawesome/free-solid-svg-icons";


function ListArray({
                       list, depth = 0, onChange,
                        data, expandedMenus, setExpandedMenus, required, recursive,
                   }) {

    const toggleSubMenu = (menuId) => {
        setExpandedMenus((prevState) => {
            return {
                ...prevState,
                [menuId]: !prevState[menuId],
            }
        });
    };

    return (
        // <ul className={` ${depth > 0 ? `pl-5` : ``}`}>
        <ul className={``}>
            {list.length > 0 ? (
                (list.map((item, index) =>
                    <li key={item.id} className={` ${depth ==0 ? `top-parent`:``} `}>
                        <div className={`bg-white compo-each h-[30px] flex ${
                            expandedMenus[item.id] ==true ? 'bg-choice' : index % 2 === 0 ? 'bg-even' : 'bg-odd'
                        }`}
                             style={{ paddingLeft: `${depth * 20}px` }}
                        >
                            {recursive &&
                                (item.children.length > 0 ? (

                                        <FontAwesomeIcon icon={expandedMenus[item.id] ? faChevronDown: faChevronRight }
                                                         onClick={() => toggleSubMenu(item.id)}
                                                         className={`cursor-pointer w-[10px] h-[10px] p-[10px] `}/>
                                    ):(
                                        <FontAwesomeIcon icon={faMinus }
                                                         className={`w-[6px] h-[6px] p-[12px] `}/>
                                    )
                                )
                            }
                            {!recursive && <span className={'inline-block pl-[10px]'}></span>}


                            <button className={`truncate w-full text-left line-height-30 ${ data?.some(e=>e.id===item.id) ? `selected`:``}`}
                                    onClick={() => onChange(item)}>
                                 <span className={'inline-block '}> {item.name?? item.assetName}</span>
                                {item.assetName && <span className={`inline-block float-right mr-[10px]`}>{item.assetCode}</span>}
                            </button>
                        </div>

                        {
                            <>
                                {expandedMenus[item.id] && item.children && item.children.length > 0 &&
                                    (<ListArray list={item.children}
                                                depth={depth + 1}
                                                onChange={onChange}
                                                data={data}
                                                expandedMenus={expandedMenus}
                                                setExpandedMenus={setExpandedMenus}
                                                required={required} recursive={recursive}/>)
                                }
                            </>
                        }
                    </li>
                ))
            ):(
                <>
                    <NoSelected  title={"코드를 생성하세요 : 환경설정"} />
                </>
            )
            }

        </ul>
    )
}

export {ListArray}